import {
  CELL_SIZE,
} from './render_properties';

export default class CanvasSizeCalculator {
  constructor(canvasObjects, canvasSize = {}) {
    this.canvasObjects = canvasObjects;
    this.DEFAULT_CANVAS_WIDTH = canvasSize.width || 600;
    this.DEFAULT_CANVAS_HEIGHT = canvasSize.height || 300;
    this.PADDING = 50;
  }

  static create(positions, landmarks, canvasSize = {}) {
    const collection = {};
    positions.forEach(position => {
      collection[position.key] = position;
    });
    landmarks.forEach(landmark => {
      collection[landmark.key] = landmark;
    });
    return new CanvasSizeCalculator(collection, canvasSize);
  }

  updateObject(object) {
    this.canvasObjects[object.key] = object;
    return this;
  }

  calculateWithUpdatedObject(object) {
    this.updateObject(object);
    if (object.topRightX() > this.maxX) this.maxX = object.topRightX();
    if (object.bottomLeftY() > this.maxY) this.maxY = object.bottomLeftY();
    const width = this.maxX * CELL_SIZE + this.PADDING;
    const height = this.maxY * CELL_SIZE + this.PADDING;
    return { width, height };
  }

  calculate() {
    this.maxX = this.DEFAULT_CANVAS_WIDTH / CELL_SIZE;
    this.maxY = this.DEFAULT_CANVAS_HEIGHT / CELL_SIZE;
    Object.values(this.canvasObjects).forEach(obj => {
      if (obj.topRightX() > this.maxX) this.maxX = obj.topRightX();
      if (obj.bottomLeftY() > this.maxY) this.maxY = obj.bottomLeftY();
    });
    const width = this.maxX * CELL_SIZE + this.PADDING;
    const height = this.maxY * CELL_SIZE + this.PADDING;
    return { width, height };
  }

}
